// Filter and Sorting Business Logic Utilities
import orderBy from 'lodash.orderby';
import { getRating } from '../helpers';

/**
 * Apply filters and sorting to movie data
 * @param {Array} data - Array of movies
 * @param {Array} appliedFilters - Array of filter objects
 * @param {Array} appliedSorting - Array of sorting objects
 * @param {number|null} user_id - Current user ID for my_rating filters
 * @returns {Array} Filtered and sorted data
 */
export const applySortingAndFilter = (
  data,
  appliedFilters,
  appliedSorting,
  user_id = null,
) => {
  const filteredData = data.filter((item) => {
    let shouldReturn = true;
    for (let i = 0; i < appliedFilters.length; i++) {
      const filter = appliedFilters[i];
      const ids = filter.id.split('.');
      const id = ids[0];
      let result;
      if (filter.enabled) {
        let value = filter.value;
        if (id == '_ratedBy') {
          result = item.user_ratings.find((r) => {
            return (
              (r.username == value || r.display_name == value) &&
              r.rating != null
            );
          });
        } else if (id == '_watchlistedBy') {
          result = item.user_ratings.find((r) => {
            return (
              (r.username == value || r.display_name == value) &&
              r.watchlisted == true
            );
          });
        } else if (id == 'my_rating') {
          let fieldValue = user_id ? getRating(item, user_id) : null;
          if (filter.operator == '>=') {
            result = fieldValue >= value;
          } else if (filter.operator == '>') {
            result = fieldValue > value;
          } else if (filter.operator == '<=') {
            result = fieldValue <= value;
          } else if (filter.operator == '<') {
            result = fieldValue < value;
          } else if (filter.operator == '==') {
            result = fieldValue == value;
          } else if (filter.operator == '!=') {
            result = fieldValue != value;
          }
        } else {
          let fieldValue = item[id];

          if (filter.operator == 'contains') {
            if (Array.isArray(fieldValue)) {
              if (ids.length > 1 && Object.getOwnPropertyNames(ids[1])) {
                result =
                  fieldValue.find(
                    (item) => item[ids[1]].toLowerCase() == value.toLowerCase(),
                  ) != null;
              } else {
                result = fieldValue.includes(value);
              }
            } else {
              result = fieldValue.toLowerCase().includes(value.toLowerCase());
            }
          } else if (filter.operator == 'not_contains') {
            if (Array.isArray(fieldValue)) {
              if (ids.length > 1 && Object.getOwnPropertyNames(ids[1])) {
                result =
                  fieldValue.find(
                    (item) => item[ids[1]].toLowerCase() == value.toLowerCase(),
                  ) == null;
              } else {
                result = !fieldValue.includes(value);
              }
            } else {
              result = !fieldValue.toLowerCase().includes(value.toLowerCase());
            }
          } else if (filter.operator == '>=') {
            result = fieldValue >= value;
          } else if (filter.operator == '>') {
            result = fieldValue > value;
          } else if (filter.operator == '<=') {
            result = fieldValue <= value;
          } else if (filter.operator == '<') {
            result = fieldValue < value;
          } else if (filter.operator == '==') {
            result = fieldValue == value;
          } else if (filter.operator == '!=') {
            result = fieldValue != value;
          }
        }
      } else {
        result = true;
      }
      shouldReturn = shouldReturn && result;
    }
    return shouldReturn;
  });

  const enabledSortings = appliedSorting.filter((item) => item.enabled);

  const directions = enabledSortings.map((item) => item.direction || '');

  const sortedData = orderBy(
    filteredData,
    enabledSortings.map((item) => {
      return (o) => {
        if (item.id === 'my_rating' && user_id) {
          return getRating(o, user_id) || 0;
        }
        return o[item.id] || '';
      };
    }),
    directions,
  );
  return sortedData;
};
